import React from 'react';
import { DialogTitle, DialogContent, Button, Typography, Box, Divider, Paper } from '@mui/material';
import { ChatLogBooking } from '../../types/chat_booking';
import { ChatLogsT } from '../../types/chat';
import { format } from 'date-fns';
import { Message } from '../../components/chat/ChatHistory';

interface ChatLogDetailProps {
  chatLog: ChatLogBooking | ChatLogsT;
  onClose: () => void;
}

const ChatLogDetail: React.FC<ChatLogDetailProps> = ({ chatLog, onClose }) => {
  const history = 'chatHistory' in chatLog ? chatLog.chatHistory : chatLog.chatLogs;

  return (
    <Paper>
      <DialogTitle
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Chat Log Detail
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {chatLog.uuid}
          </Typography>
        </Box>
        <Button onClick={onClose}>Close</Button>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', textAlign: 'center', mb: 2 }}
        >
          Conversation started at{' '}
          {format(new Date(chatLog.updatedAt || Date.now()), 'MMM d, yyyy h:mm a')}
        </Typography>

        <Box sx={{ mb: 3 }}>{history?.map((msg, i) => <Message key={i} message={msg} />)}</Box>
      </DialogContent>
    </Paper>
  );
};

export default ChatLogDetail;
